import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PageStep from "components/PageStep";
import { useNavigate } from 'react-router-dom';
import useBookingPage from "services/store/BookingPage";
import useConsultStore from "services/store/consultModule";
import useDoctorStore from "services/store/doctorModule";
import useSlotStore from "services/store/SlotModule";
import { CreateBooking } from "services/Api/Module/Meeting";
import moment from 'moment';
import ModalBookingSuccess from "components/modal/ModalBookingSuccess";
import ModalCancelBooking from "components/modal/ModalCancelBooking";
import ModalFailMeeting from "components/modal/ModalFailMeeting";
import ModalNetwork from "components/modal/ModalNetwork";
import useLoadedStore from "services/store/LoadedPage";
import ModalFail from "components/modal/ModalFail";
import config from "util/config";
import ModalNotEnoughPoint from "components/modal/ModalNotEnoughPoint";
import ModalFreeQuota from "components/modal/ModalFreeQuota";
import { Checkbox } from "primereact/checkbox";

const CONFIG = config.config()
const Conclustion = () => {
    const TERMS_PDF_URL = "/documents/terms-and-conditions.pdf";
    const liffId = CONFIG.LIFF_ID;
    const { consults, getConsultList } = useConsultStore(state => state); // ดึง state
    const { profile, step0, step1, step2, step3, resetBooking } = useBookingPage();
    const { doctors, getDoctorList } = useDoctorStore(state => state); // ดึง state
    const { slots, getSlotList } = useSlotStore(state => state); // ดึง state
    const [isOpenSuccess, setIsOpenSuccess] = useState(false); // ดึง state
    const [isOpenFail, setIsOpenFail] = useState(false); // ดึง state
    const [isOpenNetwork, setIsOpenNetwork] = useState(false); // ดึง state
    const [isOpenFailMeeting, setIsOpenFailMeeting] = useState(false); // ดึง state
    const [isCancelBooking, setIsCancelBooking] = useState(false); // ดึง state
    const [isOpenNoPoint, setIsOpenNoPoint] = useState(false); // ดึง state
    const [statusCode, setStatusCode] = useState(false); // ดึง state
    const [disbutton, setDisButton] = useState(false);
    const { isBooking } = useLoadedStore();
    const [isOpenFreeQuota, setIsOpenFreeQuota] = useState(false); // ดึง state
    const [isConsent, setIsConsent] = useState(false); // ดึง state
    const [isHealthConsent, setIsHealthConsent] = useState(false); // ดึง state
    const consentRowStyle = {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "8px"
    };
    const consentLabelStyle = {
        display: "block",
        flex: 1,
        marginLeft: 0
    };

    const navigate = useNavigate();
    const isSlotBookable = (slotItems = []) => {
        const selectedSlot = slotItems.find(item => item.id == step3.slot);
        if (!selectedSlot?.slotStatus || !selectedSlot?.consultTimeStart) {
            return false;
        }

        const slotStart = moment(
            `${moment(step3.consultDate).format("YYYY-MM-DD")} ${selectedSlot.consultTimeStart}`,
            ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"],
            true
        );

        return slotStart.isValid() && slotStart.isAfter(moment().add(10, "minutes"));
    };

    const handleNext = async () => {
        if (disbutton) {
            return;
        }

        setDisButton(true);
        try {
            if (!isSlotBookable(slots)) {
                setIsOpenFailMeeting(true);
                return;
            }

            const latestSlots = await getSlotList(
                step2.doctor,
                profile.ConsultSelected,
                moment(step3.consultDate).format("YYYY-MM-DD"),
                profile.LineMid
            );

            if (!isSlotBookable(latestSlots?.resultData ?? [])) {
                setIsOpenFailMeeting(true);
                return;
            }

            const payload = {
                userId: profile.UserId,
                consultSelected: profile.ConsultSelected,
                lineMid: profile.LineMid,
                smConsultTopic: null,
                smSlot: step3.slot,
                note: step1.note,
                usedpoint: profile.Point,
                isConsent: step0.isConsent,
                motherStage: profile.MotherStage,
                babyAge: profile.BabyAge,
                pregnancyAge: profile.PregnancyAge,
                campaignId: profile.CampaignId,
                smDoctor: step2.doctor,
                childId: profile.ChildId,
                isHealthDataConsent: isHealthConsent,
                isRecordConsent: 0
            };
            console.log(profile.pregnancyAge);
            await postMeeting(payload);
        } catch (err) {
            console.log('Out error', err);
            const resultCode = err?.response?.data?.resultCode;
            if (resultCode == 40401) {
                setIsOpenFailMeeting(true);
            } else {
                setIsOpenNetwork(true);
            }
        } finally {
            setDisButton(false);
        }
    };
    const handlePrev = () => {
        setIsCancelBooking(true);
    };
    const handleLink = () => {
        window.location.href = `https://liff.line.me/${liffId}`;
    };
    const handleFail = () => {
        setIsOpenFailMeeting(false);
        navigate('/booking-time');
    }

    const handleFreeQuota = () => {
        setIsOpenFreeQuota(false)
    };

    const fetchConsultList = async () => {
        try {
            const resApi = await getConsultList(profile.ConsultSelected)
        } catch (err) {
            console.log('Out error', err)
            alert("มีบางอย่างผิดพลาด")
        }
    };
    const fetchDoctorList = async () => {
        try {
            const resApi = await getDoctorList(profile.MotherStage)
        } catch (err) {
            console.log('Out error', err)
            alert("มีบางอย่างผิดพลาด")
        }
    };
    const fetchSlotList = async () => {
        try {
            const resApi = await getSlotList(step2.doctor, profile.ConsultSelected, moment(step3.consultDate).format("YYYY-MM-DD"), profile.LineMid)
            console.log("fetchSlotlist", resApi)
            if (!isSlotBookable(resApi?.resultData ?? [])) {
                setIsOpenFailMeeting(true);
            }
        } catch (err) {
            console.log('Out error', err)
            setIsOpenNetwork(true);
        }
    };
    const postMeeting = async (payload = {}) => {
        const resApi = await CreateBooking({ data: payload })
        if (resApi?.data?.resultCode == 20000) {
            setIsOpenSuccess(true);
        } else if (resApi?.data?.resultCode == 40401) {
            setIsOpenFailMeeting(true);
        } else if (resApi?.data?.resultCode == 40501) {
            setStatusCode(resApi?.data?.resultCode || "");
            setIsOpenNoPoint(true);
        } else {
            setStatusCode(resApi?.data?.resultCode || "");
            setIsOpenFail(true);
        }
    };
    const handleCancelBooking = async () => {
        await resetBooking();
        navigate("/doctor-select");
    };
    useEffect(() => {
        if (!isBooking) {
            resetBooking();
            navigate("/");
        }
        if (profile.Point === 0) {
            setIsOpenFreeQuota(true)
        }
        fetchConsultList();
        fetchDoctorList();
        fetchSlotList();
    }, []);
    const TimeDiff = (startDateTime, endDateTime) => {
        const startTime = moment(startDateTime, ["HH:mm:ss", "HH:mm"], true);
        const endTime = moment(endDateTime, ["HH:mm:ss", "HH:mm"], true);
        if (!startTime.isValid() || !endTime.isValid()) {
            return "-";
        }

        const difference = endTime.diff(startTime, "minutes");
        return `${difference} นาที`;
    };

    const formatSlotTime = (slotItem) => {
        const startTime = moment(slotItem?.consultTimeStart, ["HH:mm:ss", "HH:mm"], true);
        const endTime = moment(slotItem?.consultTimeEnd, ["HH:mm:ss", "HH:mm"], true);
        if (!startTime.isValid() || !endTime.isValid()) {
            return "-";
        }

        return `${startTime.format("HH:mm")} - ${endTime.format("HH:mm")} น.`;
    };

    const selectDoctor = (doctors ?? []).find(item => item.id == step2.doctor)
    const selectConsult = (consults ?? []).find(item => item.id == step1.consult)
    const selectSlot = (slots ?? []).find(item => item.id == step3.slot)
    console.log("slots", slots)
    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="pageConclustion">
                <main>
                    <header>
                        <div className="tHead">
                            <p>การนัดหมายของคุณแม่</p>
                        </div>
                    </header>
                    <div className="wrapContent">
                        <section id="pConclusion">
                            {profile.ConsultSelected === 'doctor' ?
                                (<PageStep step={3} />) : (<PageStep step={2} />)
                            }
                            <div className="bContent">
                                <h2>สรุปข้อมูลการนัดหมาย</h2>
                                <div className="bDetail">
                                    <p className="topic">รายละเอียดการนัดหมาย</p>
                                    <div className="tDetail">
                                        <div className="meetingDetail">
                                            <p>วันที่</p>
                                            <p className="tBold">{moment(step3.consultDate).format("YYYY-MM-DD")}</p>
                                        </div>
                                        <div className="meetingDetail">
                                            <p>เวลา</p>
                                            <p className="tBold">{formatSlotTime(selectSlot)}</p>
                                        </div>
                                        {/* <div className="meetingDetail">
                                            <p>สถานะ</p>
                                            <p className="tBold">{profile.MotherStage == "Pregnancy" ? "คุณแม่ตั้งครรภ์" : "คุณแม่มีบุตร"}</p>
                                        </div>
                                        <div className="meetingDetail">
                                            <p>หัวข้อที่ปรึกษา</p>
                                            <p className="tBold">{selectConsult?.name}</p>
                                        </div>
                                        <div className="meetingDetail">
                                            <p>รายละเอียด</p>
                                            <p className="tBold">{step1.note}</p>
                                        </div> */}
                                        {profile.ConsultSelected == "doctor" ? (
                                            <div className="meetingDetail">
                                                <p>ผู้เชี่ยวชาญ</p>
                                                <p className="tBold">{selectDoctor?.firstName} {selectDoctor?.lastName}</p>
                                            </div>
                                        ) : null}
                                        <div className="meetingDetail">
                                            <p>ระยะเวลา</p>
                                            <p className="tBold">{TimeDiff(selectSlot?.consultTimeStart, selectSlot?.consultTimeEnd)}</p>
                                        </div>
                                    </div>
                                    <div className="bNote">
                                        <p>หมายเหตุ</p>
                                        <div className="tNote">
                                            <p>กรุณาเข้านัดปรึกษาตามวัน / เวลาที่ระบุ<br /> หากเข้ารับคำปรึกษาล่าช้าเกินกว่า 10 นาที <br />การนัดหมายในครั้งนั้นจะถูกยกเลิกโดยอัตโนมัติ</p>
                                            <br />
                                            <p className="tRed">
                                                !! ขอสงวนสิทธิ์ในการไม่บันทึกเสียง / ภาพ หรือ วิดีโอ ขณะรับคำปรึกษาในทุกกรณี
                                            </p>
                                        </div>
                                    </div>
                                    <div className="bConsent" style={{ textAlign: "left" }}>
                                        <div className="consentRow" style={consentRowStyle}>
                                            <Checkbox onChange={e => setIsConsent(e.checked)} checked={isConsent}></Checkbox>
                                            <label htmlFor="ingredient1" className="labeConsent" style={consentLabelStyle}>
                                                ยอมรับรายละเอียดและเงื่อนไขการให้บริการ{" "}
                                                <a
                                                    href={TERMS_PDF_URL}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "#0d6efd", textDecoration: "underline" }}
                                                >
                                                    Link
                                                </a>
                                            </label>
                                        </div>
                                        <div className="consentRow" style={consentRowStyle}>
                                            <Checkbox onChange={e => setIsHealthConsent(e.checked)} checked={isHealthConsent}></Checkbox>
                                            <label className="labeConsent" style={consentLabelStyle}>
                                                ข้าพเจ้ายินยอมให้ Nestl<span className="consent-e">é</span> (Thai) Ltd. และบริษัทในเครือภายในกลุ่มของ Nestl<span className="consent-e">é</span> (Thai) Ltd. ("Nestl<span className="consent-e">é</span>") และ แพทย์หรือพยาบาลผู้ให้บริการ เก็บรวบรวม ใช้ และ/หรือ เปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าซึ่งรวมถึงการบันทึกเสียง และ/หรือภาพ และ/หรือข้อความ จากการสนทนาผ่านช่องทาง LINE Official Account ภายใต้บริการ S-Mom TeleCare เพื่อวัตถุประสงค์ในการพัฒนาการบริการผ่านระบบ TeleCare
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <section id="pActionBtn">
                                <div className="bBtn">
                                    <button className="btn outline" onClick={handlePrev}>ยกเลิก</button>
                                    <button className="btn" onClick={handleNext} id="confirm" disabled={disbutton || !isConsent || !isHealthConsent}>
                                        ยืนยันการนัดหมาย
                                    </button>
                                    {/* <!-- เมื่อเลือกประเภทแล้วให้เอา disabled ออก --> */}
                                </div>
                            </section>
                        </section>
                    </div>
                </main>
            </div>
            <ModalBookingSuccess open={isOpenSuccess} onClose={handleLink} />
            <ModalFreeQuota open={isOpenFreeQuota} onClose={handleFreeQuota} />
            <ModalFailMeeting open={isOpenFailMeeting} onFail={handleFail} onClose={() => setIsOpenFailMeeting(false)} />
            <ModalFail open={isOpenFail} onClose={() => setIsOpenFail(false)} statuscode={statusCode} />
            <ModalNetwork open={isOpenNetwork} onClose={handleLink} />
            <ModalNotEnoughPoint open={isOpenNoPoint} onClose={() => setIsOpenNoPoint(false)} statuscode={statusCode} />
            <ModalCancelBooking open={isCancelBooking} onClose={() => setIsCancelBooking(false)} onCancel={handleCancelBooking} />
        </div>
    )
}

export default Conclustion
